import React, { useEffect, useState } from "react";
import { Select } from "antd";
import PropTypes from "prop-types";
import { CustomTimeDropdown } from "../CustomTimeDropdown";

const { Option } = Select;

const predefinedOptions = [
    { label: "15 min", value: 15 },
    { label: "30 min", value: 30 },
    { label: "45 min", value: 45 },
    { label: "1 hr", value: 60 }
];

export const BufferTime = ({ form, expandedRowData }) => {
    const [value, setValue] = useState(null);
    const [customHour, setCustomHour] = useState(0);
    const [customMinute, setCustomMinute] = useState(0);
    const [error, setError] = useState("");
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const existingValue = expandedRowData?.trip_buffer_time
        if (existingValue != null) {
            setValue(existingValue);
            form.setFieldValue("trip_buffer_time", existingValue)
            const isPredefined = predefinedOptions.some((opt) => opt.value === existingValue);
            if (!isPredefined && !isNaN(existingValue)) {
                setCustomHour(Math.floor(existingValue / 60));
                setCustomMinute(existingValue % 60);
            }
        } else {
            form.setFieldValue("trip_buffer_time", null)
            setValue()
            setCustomHour();
            setCustomMinute();
        }
    }, [form, expandedRowData]);

    const getDropdownRender = (menu) =>
    (
        <CustomTimeDropdown
            menu={menu}
            customHour={customHour}
            customMinute={customMinute}
            error={error}
            setCustomHour={setCustomHour}
            setCustomMinute={setCustomMinute}
            handleCustomChange={handleCustomChange}
            label="Enter Custom Buffer Time"
        />
    );

    const handleSelect = (val) => {
        setValue(val);
        form.setFieldValue("trip_buffer_time", val);
        setOpen(false);
    };

    const handleCustomChange = () => {
        if (customMinute < 0 || customMinute > 59) {
            setError("Minutes must be 0–59");
            return;
        }

        const total = customHour * 60 + customMinute;
        setValue(total);
        form.setFieldValue("trip_buffer_time", total);
        setError("");
        setOpen(false);
    };

    return (
        <div>
            <Select
                open={open}
                onDropdownVisibleChange={(visible) => setOpen(visible)}
                style={{ width: "100%" }}
                placeholder="Select"
                value={
                    predefinedOptions.find((opt) => opt.value === value)?.label ||
                    (value ? `${Math.floor(value / 60)} hr ${value % 60} min` : undefined)
                }
                onSelect={handleSelect}
                dropdownRender={getDropdownRender}
            >
                {predefinedOptions.map((opt) => (
                    <Option key={opt.value} value={opt.value}>
                        {opt.label}
                    </Option>
                ))}
            </Select>
        </div >
    );
};

BufferTime.propTypes = {
  form: PropTypes.shape({
    getFieldValue: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  expandedRowData: PropTypes.shape({
    trip_buffer_time: PropTypes.number,
  }),
};
